export default {
      id: "vague_agenda-usage",
      viewBox: "0 0 2000 213",
      url: "../dist/images/" + "sprite.svg#vague_agenda-usage",
      toString: function () {
        return this.url;
      }
    }